 <!-- DELETE-MODAL -->
 <div class="master-modal delete-modal" role="dialog">
   <div class="modal-dialog">
     <!-- Modal content-->
     <div class="modal-content">
       <!-- Modal-Header -->
       <div class="modal-header">
         <h4 class="modal-title">Cancel Order</h4>
         <div class="modal_close_btn">
           <span (click)="dialogClose('no')" class="modal-close"><i class="material-icons">close</i></span>
         </div>
       </div>
       <form [formGroup]="changeStatusForm" (ngSubmit)="updateStatus()">
         <!-- Modal-Body -->
         <!-- Modal content-->
         <perfect-scrollbar class="modal-body-scrollbar">
           <div mat-dialog-content>
             <div class="modal-body">
               <div fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
                 fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="8px">
                 <div fxLayout="column" fxFlex="100" fxFlexFill>
                   <div class="notification-delete">
                     <p>Do you really want to cancel the Order?</p>
                   </div>
                   <!-- Message-TEXT-AREA-->
                   <div class="custom-form-group mt-20">
                     <label class="custom-label fx-display" for="">Reason <span class="star">*</span> </label>
                     <div class="custom-form-control">
                       <mat-form-field appearance="outline">
                         <textarea rows="5" cols="5" matInput formControlName="message"
                           placeholder="Enter reason"></textarea>
                         <mat-error *ngIf="message.invalid && ( message.dirty || message.touched )">
                           <span>Please provide a valid value</span>
                         </mat-error>
                       </mat-form-field>
                     </div>
                   </div>
                 </div>
               </div>
             </div>
           </div>
         </perfect-scrollbar>
         <!-- Modal-Footer -->
         <div class="modal-footer">
           <div mat-dialog-actions class="modal_footer">
             <!-- <button type="button" mat-button (click)="dialogClose('no')" class="modal-cancel-btn modal-footer-btn">
               <span>Cancel</span>
             </button> -->
             <button type="submit" class="modal-save-btn global-btn modal-footer-btn" mat-button>
               <span>Cancel Order</span>
             </button>
           </div>
         </div>
       </form>
     </div>
   </div>
 </div>
